<template>
  <div class="bg-[#FFD639] py-[0.8em] px-[3em] relative">
    <p class="text-center text-tape">
      <slot></slot>
    </p>
    <div
      v-show="isCloseable"
      class="w-[12px] absolute top-[20px] right-[16px] cursor-pointer"
      @click="$emit('closeAnnouncementBar', true)"
    >
      <img src="/assets/images/navbar/close.svg" alt="close" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isCloseable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped lang="scss"></style>
